import { ApplicationRef, ComponentFactoryResolver, ComponentRef, Injectable, Injector, Type } from '@angular/core';
import { UtilitiesModule } from '../utilities.module';

@Injectable({
  providedIn: UtilitiesModule
})
export class ApplicationService {

  constructor(private appRef: ApplicationRef, private cfr: ComponentFactoryResolver, private injector: Injector) { }

  attach<T>(component: Type<T>, hostview: HTMLElement): ComponentRef<T> {
    const componentFactory = this.cfr.resolveComponentFactory(component)
    const componentRef = componentFactory.create(this.injector)
    this.appRef.attachView(componentRef.hostView)
    hostview.appendChild(componentRef.location.nativeElement)
    return componentRef
  }

  destroy(component: ComponentRef<any>) {
    this.appRef.detachView(component.hostView)
    component.destroy()
  }
}
